import { useState } from 'react';

const QuickAdd = props => {
    const [addBill, handleAddBillChange] = useState('')
    const [isAddingBill, toggleIsAddingBill] = useState(false)
    const quickAddBills = () => {
        if (!addBill.replace(/\s/g), "") {
            return;
        }
        toggleIsAddingBill(true);
        props.quickAddBills(addBill, err => {
            toggleIsAddingBill(false);
            if (!err) { handleAddBillChange('') };
        });
    }

    return (
        <>
            <div className="quick-add-container">
                <label className="screen-reader-only" htmlFor="bill-quick-add">Add bill(s)</label>
                <input
                    id="bill-quick-add"
                    type="text"
                    onKeyDown={e => {
                        if (e.key === "Enter") {
                            e.stopPropagation();
                            quickAddBills()
                        }
                    }}
                    placeholder="Add bill(s)"
                    value={addBill}
                    onChange={e => handleAddBillChange(e.target.value)}
                />
                {isAddingBill ?
                    <span className="small-spinner"></span>
                    :
                    <button aria-label='add bill' type="button" disabled={props.collectionIsSaving} onClick={quickAddBills} id="bill-quick-add-button" className="small-button button add-wide" />
                }
            </div>
            {props.quickAddErr &&
                <span className="small-text fail">{props.quickAddErr}</span>
            }
        </>
    );
}

export default QuickAdd;
